// client/src/routes/app/repairs/index.tsx — SCR-REP-001 · MAINT-007 (04 §8.9).
//
// Replaces UI-003's `PlaceholderScreen`, which named this item as its owner.
//
// The route owns the URL state and nothing else: `validateSearch` runs the §9.2.3 schema and the
// screen reads it back typed, so a filtered board is shareable, survives refresh, and Back is a
// filter-undo.
//
// `Operations.Read` is UI-003's guard and stays: the sidebar hides the entry, and this renders
// SCR-SYS-403 for the URL that was typed anyway (§9.2.2). Every write on the detail screen is
// mirrored against `Operations.Write`, which the `accountant` role does not hold.

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { RepairBoard } from '@/features/repairs/RepairBoard';
import { repairSearchSchema, type RepairSearch } from '@/features/repairs/search';

export const Route = createFileRoute('/app/repairs/')({
  validateSearch: repairSearchSchema,
  component: RepairsScreen,
});

function RepairsScreen() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RequirePermission permission="Operations.Read">
      <RepairBoard
        search={search}
        onSearchChange={(next: (previous: RepairSearch) => RepairSearch) => {
          void navigate({ search: next });
        }}
      />
    </RequirePermission>
  );
}
